import { useActionsFiltersStore } from '@/contexts/action-plans/stores/ActionsFilters.store'
import { useActionsListFiltersStore } from '@/contexts/action-plans/stores/ActionsListFilters.store'
import { useActionPlanFiltersStore } from '@/contexts/action-plans/stores/ActionPlanFilters.store'
import { useActionPlansListFiltersStore } from '@/contexts/action-plans/stores/ActionPlansListFilters.store'
import { useOrganizationPerimetersFiltersStore } from '@/contexts/organization/stores/OrganizationPerimetersFilters.store'

export function clearFilterStores(): void {
  const filterStores = [
    useActionsFiltersStore(),
    useActionsListFiltersStore(),
    useActionPlansListFiltersStore(),
    useActionPlanFiltersStore(),
    useOrganizationPerimetersFiltersStore(),
  ]

  filterStores.forEach((store) => {
    store.$reset()
  })
}
